module.exports = __webpack_public_path__ + "img/tag1.b4c15394.png";